(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/modal.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/modal.js');
"use strict";



const {
  useState,
  useEffect,
  useCallback,
  useRef
} = React;
const {
  createPortal
} = ReactDOM;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const {
  dialog
} = svs.ui;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  getModalRoot
} = svs.components.sport.quickplayModal;
const CSS_SELECTOR_FOR_FOCUSABLE_ELEMENTS = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const IS_DISABLING_BACKGROUND_SCROLL = true;


const defaultProps = {
  children: null,
  className: null,
  handleCloseModal: null,
  hasPortal: false,
  initialFocusSelector: null,
  isClosingOnBackgroundClick: false
};
const ModalErrorDialog = _ref => {
  let {
    handleCloseModal,
    error
  } = _ref;
  useEffect(() => {
    dialog.api.add(new dialog.Confirm({
      branding: dialog.branding.SPORT,
      area: dialog.area.POPUP,
      type: dialog.type.DEFAULT,
      title: 'Något gick visst fel',
      message: [{
        type: dialog.message.TEXT,
        text: 'Det gick inte att öppna modalen! Försök igen senare'
      }],
      actions: [{
        title: 'Ok'
      }]
    }));
    if (handleCloseModal) {
      handleCloseModal();
    }
  }, [handleCloseModal]);
  useEffect(() => {
    logger.info("Modal failed with error \"".concat(error === null || error === void 0 ? void 0 : error.message, "\""));
  }, [error]);
  return null;
};
const Modal = props => {
  const {
    ariaLabel,
    className,
    children,
    handleCloseModal,
    hasPortal,
    initialFocusSelector,
    isClosingOnBackgroundClick
  } = props;
  const backgroundRef = useRef();
  const [hasSetInitialFocus, setHasSetInitialFocus] = useState(false);
  useEffect(() => {
    if (hasSetInitialFocus || !backgroundRef.current) {
      return;
    }
    const _setInitialFocusInsideModal = () => {
      const element = backgroundRef.current.querySelector(initialFocusSelector || CSS_SELECTOR_FOR_FOCUSABLE_ELEMENTS);
      if (element) {
        element.focus();
        setHasSetInitialFocus(true);
      }
    };
    _setInitialFocusInsideModal();
  }, [initialFocusSelector, hasSetInitialFocus]);

  const [prevFocusElementOnPage] = useState(document.activeElement);
  useEffect(() => {
    const _returnFocusToPrevElementWhenClosingModal = () => {
      if (prevFocusElementOnPage !== null && prevFocusElementOnPage !== void 0 && prevFocusElementOnPage.focus) {
        prevFocusElementOnPage.focus();
        prevFocusElementOnPage.blur();
      }
    };
    return _returnFocusToPrevElementWhenClosingModal;
  }, [prevFocusElementOnPage]);
  useEffect(() => {
    const _closeModalOnEscape = event => {
      if (event.key === 'Escape' && typeof handleCloseModal === 'function') {
        handleCloseModal();
      }
    };
    document.addEventListener('keydown', _closeModalOnEscape);
    return () => document.removeEventListener('keydown', _closeModalOnEscape);
  }, [handleCloseModal]);
  useEffect(() => {
    const backgroundElement = backgroundRef.current;
    if (!isClosingOnBackgroundClick || !backgroundElement) {
      return;
    }
    const _closeModalOnBackgroundClick = event => {
      if (event.target === backgroundRef.current) {
        handleCloseModal();
      }
    };
    backgroundElement.addEventListener('click', _closeModalOnBackgroundClick);
    return () => backgroundElement.removeEventListener('click', _closeModalOnBackgroundClick);
  }, [isClosingOnBackgroundClick, handleCloseModal]);
  useEffect(() => {
    const _handleSpecialKeys = event => {
      if (event.key === 'Tab' && backgroundRef.current) {
        _loopFocusInsideModalOnTabKey(event, backgroundRef.current);
      }
    };
    document.addEventListener('keydown', _handleSpecialKeys);
    return () => document.removeEventListener('keydown', _handleSpecialKeys);
  }, []);
  useEffect(() => {
    if (IS_DISABLING_BACKGROUND_SCROLL) {
      const cleanUpActions = [];
      const _adaptStyleAndPrepareCleanUp = (element, newStyle) => {
        const oldStyle = element.getAttribute('style');
        if (oldStyle) {
          element.setAttribute('style', "".concat(oldStyle, "; ").concat(newStyle));
          cleanUpActions.push(() => element.setAttribute('style', oldStyle));
        } else {
          element.setAttribute('style', newStyle);
          cleanUpActions.push(() => element.removeAttribute('style'));
        }
      };
      const scrollbarWidthPx = window.innerWidth - document.body.clientWidth;
      const newBodyStyle = "overflow: hidden;".concat(scrollbarWidthPx ? " padding-right: ".concat(scrollbarWidthPx, "px;") : '');
      _adaptStyleAndPrepareCleanUp(document.body, newBodyStyle);
      const headerContainer = document.querySelector('.js-fixed-top-content');
      if (scrollbarWidthPx && headerContainer) {
        _adaptStyleAndPrepareCleanUp(headerContainer, "padding-right: ".concat(scrollbarWidthPx, "px;"));
        for (let i = 0; i < headerContainer.children.length; i++) {
          const styles = window.getComputedStyle(headerContainer.children[i]);
          if (styles.position === 'fixed' && parseInt(styles.right, 10) === 0) {
            _adaptStyleAndPrepareCleanUp(headerContainer.children[i], "right: ".concat(scrollbarWidthPx, "px;"));
          }
        }
      }
      if (scrollbarWidthPx && backgroundRef.current) {
        backgroundRef.current.style.paddingRight = "".concat(scrollbarWidthPx, "px");
      }
      return () => cleanUpActions.forEach(cb => cb());
    }
  }, []);
  const ErrorFallback = useCallback(_ref2 => {
    let {
      error
    } = _ref2;
    return React.createElement(ModalErrorDialog, {
      error: error,
      handleCloseModal: handleCloseModal
    });
  }, [handleCloseModal]);
  const content = React.createElement(ErrorBoundary, {
    fallback: ErrorFallback
  }, React.createElement("div", {
    "aria-label": ariaLabel,
    "aria-modal": "true",
    className: "svs-react-modal-background",
    ref: backgroundRef,
    role: "dialog"
  }, React.createElement("div", {
    className: "svs-react-modal-foreground ".concat(className || '').trim()
  }, children)));
  return hasPortal ? createPortal(content, getModalRoot({
    unmount: false
  })) : content;
};
Modal.defaultProps = defaultProps;
function _loopFocusInsideModalOnTabKey(event, element) {
  const focusableContent = element.querySelectorAll(CSS_SELECTOR_FOR_FOCUSABLE_ELEMENTS);
  if (focusableContent.length === 0) {
    return;
  }
  const firstFocusableElement = focusableContent[0];
  const lastFocusableElement = focusableContent[focusableContent.length - 1];
  if (event.shiftKey && document.activeElement === firstFocusableElement) {
    lastFocusableElement.focus();
    event.preventDefault();
  }
  if (!event.shiftKey && document.activeElement === lastFocusableElement) {
    firstFocusableElement.focus();
    event.preventDefault();
  }
}
setGlobal('svs.components.sport.quickplayModal.Modal', Modal);

 })(window);